module.exports = __webpack_public_path__ + "img/norfolk_island.d5917e0.webp";